<template>
	<!-- 修改密碼 -->
	<el-dialog :close-on-click-modal="false"  :title="$t('userInfo.userInfo')" :visible.sync="userInfoModel" top="5vh" @close="hide" :width="isphone?'90%':'80%'">
		<!-- 表單内容 -->
		
        <el-descriptions size="mini" :column="3"  v-loading="loading">
			
			<el-descriptions-item :label="$t('payList.uid')">{{user_info.client_id}}</el-descriptions-item>
			<el-descriptions-item label="UID">{{user_info.id}}</el-descriptions-item>
			
			
			

            <el-descriptions-item :label="$t('userInfo.name')">{{user_info.name}}</el-descriptions-item>
            <el-descriptions-item :label="$t('userInfo.username')">{{user_info.username}}</el-descriptions-item>
             <el-descriptions-item :label="$t('userInfo.agent')">{{user_info.agent}}</el-descriptions-item>
            <el-descriptions-item :label="$t('userInfo.status')">
                <el-tag type="success" v-if="user_info.status == 1" size="small">{{$t('status.normal')}}</el-tag>
                <el-tag type="danger" v-else size="small">{{$t('status.disable')}}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item :label="$t('userInfo.buy_status')">
                <el-tag type="success" v-if="user_info.buy_status == 1" size="small">{{$t('status.normal')}}</el-tag>
                <el-tag type="danger" v-else size="small">{{$t('status.disable')}}</el-tag>
            </el-descriptions-item>

           
            <el-descriptions-item :label="$t('userInfo.user_type')">
				<span>{{user_info.user_type == 1?$t('userList.userType1'):$t('userList.userType2')}}</span>
                
            </el-descriptions-item>
            <el-descriptions-item :label="$t('userInfo.from_type')">
                <el-tag type="info" v-if="user_info.from_type == 1" size="small">{{$t('userInfo.from_type_str.1')}}</el-tag>
                <el-tag type="info" v-if="user_info.from_type == 2" size="small">{{$t('userInfo.from_type_str.2')}}</el-tag>
                <el-tag type="info" v-if="user_info.from_type == 3" size="small">{{$t('userInfo.from_type_str.3')}}</el-tag>
            </el-descriptions-item>
			
			<el-descriptions-item :label="$t('userInfo.login_time')">{{user_info.login_time}}</el-descriptions-item>

            <el-descriptions-item :label="$t('userInfo.money')" ><span class="text_chengse">{{user_info.money}}</span></el-descriptions-item>
			
			
			
            <el-descriptions-item :label="$t('userList.quotaHaveZ')">
				<span class="">{{user_info.quota}}</span>
				 <span class="mx-1">/</span>
				<span class="text_chengse">{{user_info.have_quota}}</span>
			</el-descriptions-item>
			
			
			<el-descriptions-item :label="$t('userList.need_money')">

				<span class="text_chengse">{{user_info.need_money}}</span>
			</el-descriptions-item>
            
			
			<el-descriptions-item :label="$t('userInfo.phone')">{{user_info.phone}}</el-descriptions-item>
			
			<el-descriptions-item :label="$t('userInfo.email')">{{user_info.email}}</el-descriptions-item>

            <el-descriptions-item :label="$t('userInfo.remark')">{{user_info.remark}}</el-descriptions-item>
			<el-descriptions-item label="APIKEY">{{user_info.key}}
			
			</el-descriptions-item>
			<el-descriptions-item label="UseTime">{{user_info.use_time}}</el-descriptions-item>

        </el-descriptions>
		<div slot="footer" class="dialog-footer">
			<el-button @click="hide">{{$t('model.close')}}</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			userInfoModel: {
				type: Boolean,
				default: false
			},
			userId: {
				type: Number,
				default: 0
			},
			isphone: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				loading: false,
				user_info: {
				},
			}
		},
        watch: {
            userInfoModel(newVal) {
                if (newVal) {
                    this.fetchUserData();
                }
            }
        },
		methods: {
            fetchUserData() {
				this.loading = true;
                if (!this.userId) {
                    this.userInfoModel = false;
                    this.$message.error(this.$t('layout.userIdNo'));
                    return;
                }
                this.axios.post('/admin/user/getUserInfo', {
                    userId: this.userId
                }, {
                    token: true
                }).then(res => {
                    let all = res.data
                    if (all.code == 1) {
                        this.user_info = all.data.list
                    }
					this.loading = false;
                }).catch(err => {
                    this.userInfoModel = false;
                })
            },
			hide(){
				this.$emit('hide')
			},
		}
	}
</script>

<style>
	.phone_w{
		width: 90%;;
	}
	.pc_w{
		width: 34%;;
	}
</style>
